import React, { useEffect, useState, useRef, useMemo } from "react";
import { useParams, useHistory } from "react-router-dom"
import axios from "axios";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import { localserver } from "../../api/common";
import EventInvoice from "./invoice/invoice-web";
import moment from "moment";
import { decryptSlug } from "../../util/encryption"
import {
  FaUserCircle,
  FaTicketAlt,
  FaCreditCard,
  FaDownload,
  FaCheckCircle,
  FaIdCard,
  FaCalendar,
  FaMapMarkerAlt,
  FaReceipt,
} from "react-icons/fa"
import Header from "./Header"
import Footer from "./Footer"
import { RefundStatusUpdate,DownloadBadge,DownloadCertificate } from "../../api/Webservices";
const ArrowLeftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m12 19-7-7 7-7"></path>
    <path d="M19 12H5"></path>
  </svg>
)

const UserEventPreviewPage = () => {
  const { email, eventId } = useParams()
  const history = useHistory()
  const decryptedEmail = decryptSlug(`${email}`)
  const decryptedEventId = decryptSlug(`${eventId}`)
  const [eventDetails, setEventDetails] = useState({})
  const [getEventStatus, setGetEventStatus] = useState(false)
  const [triggerDownload, setTriggerDownload] = useState(false)
  const [isCertificateDownload, setIsCertificateDownload] = useState(false)
  const [isBadgeDownload, setIsBadgeDownload] = useState(false)
  const invoiceRef = useRef(null)

  const getEventDetailsByUser = async () => {
    if (!decryptedEmail || !eventId) {
      showToast("Invalid details", "error")
      return
    }
    try {
      setGetEventStatus(true)
      const response = await axios.post(
        `${localserver}/get_register_ticket_ByUser`,
        {
          email: decryptedEmail,
          event_id: decryptedEventId,
          attendee_id: "",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      if (response.data.success) {
        console.log("API Response:", response.data)
        setEventDetails(response.data || {})
      } else {
        console.error("Error: Failed to fetch user data")
        showToast("Failed to fetch events", "error")
      }
    } catch (error) {
      console.error("Error fetching events:", error)
      showToast("An error occurred while fetching events", "error")
    } finally {
      setGetEventStatus(false)
    }
  }

  useEffect(() => {
    getEventDetailsByUser()
  }, [eventId, decryptedEmail])

  const handleDownloadInvoice = () => {
    if (!eventDetails.data) {
      console.error("No event details available for invoice")
      showToast("Cannot generate invoice: No event data", "error")
      return
    }
    console.log("Triggering invoice download...")
    setTriggerDownload(true)
    setIsCertificateDownload(false)
    setIsBadgeDownload(false)
  }

  // const handleDownloadCertificate = () => {
  //   const attendee = eventDetails.data?.[0]
  //   if (!attendee?.certificate) {
  //     showToast("No certificate available", "error")
  //     return
  //   }
  //   console.log("Triggering certificate download...")
  //   const htmlContent = attendee.certificate

  //   const bgUrlMatch = htmlContent.match(/background:url\(['"]([^'"]+)['"]\)/)
  //   const bgUrl = bgUrlMatch ? bgUrlMatch[1] : ""

  //   const preloadImg = new Image()
  //   preloadImg.src = bgUrl

  //   preloadImg.onload = () => {
  //     console.log("Background image loaded")
  //     const printWindow = window.open("", "_blank", "width=800,height=600")
  //     if (printWindow) {
  //       printWindow.document.write(`
  //         <!DOCTYPE html>
  //         <html>
  //         <head>
  //           <title>Certificate</title>
  //           <style>
  //             @media print {
  //               * {
  //                 -webkit-print-color-adjust: exact !important;
  //                 color-adjust: exact !important;
  //                 print-color-adjust: exact !important;
  //               }
  //               body {
  //                 margin: 0 !important;
  //                 padding: 0 !important;
  //                 -webkit-print-color-adjust: exact !important;
  //               }
  //               .certificate {
  //                 background-image: url('${bgUrl}') !important;
  //                 background-size: cover !important;
  //                 background-position: center !important;
  //                 background-repeat: no-repeat !important;
  //                 -webkit-print-color-adjust: exact !important;
  //                 width: 384px !important;
  //                 height: 576px !important;
  //                 margin: 0 auto !important;
  //                 page-break-inside: avoid !important;
  //               }
  //               .text-field {
  //                 -webkit-print-color-adjust: exact !important;
  //                 color: inherit !important;
  //               }
  //             }
  //             body {
  //               font-family: Arial, sans-serif;
  //               margin: 0;
  //               padding: 20px;
  //               background: white;
  //             }
  //             .certificate {
  //               position: relative;
  //               width: 384px;
  //               height: 576px;
  //               margin: 0 auto;
  //               border: 1px solid #ccc;
  //               border-radius: 8px;
  //               overflow: hidden;
  //             }
  //             .text-field {
  //               position: absolute;
  //               padding: 10px 14px;
  //               font-size: 16px;
  //               font-family: 'Arial', sans-serif;
  //               font-weight: 700;
  //               color: #000000;
  //               text-align: center;
  //               background: transparent;
  //               border: none;
  //               outline: none;
  //               pointer-events: none;
  //               white-space: nowrap;
  //               overflow: hidden;
  //               text-overflow: ellipsis;
  //               line-height: 1.2;
  //               width: 200px;
  //               height: 50px;
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           ${htmlContent.replace(/<body>/, "").replace(/<\/body><\/html>/, "</body></html>")}
  //           <script>
  //             window.onload = function() {
  //               setTimeout(function() {
  //                 window.print();
  //                 setTimeout(function() {
  //                   window.close();
  //                 }, 1000);
  //               }, 500);
  //             };
  //           </script>
  //         </body>
  //         </html>
  //       `)
  //       printWindow.document.close()
  //     }
  //   }

  //   preloadImg.onerror = () => {
  //     console.error("Failed to load background image")
  //     const printWindow = window.open("", "_blank", "width=800,height=600")
  //     if (printWindow) {
  //       printWindow.document.write(htmlContent)
  //       printWindow.document.close()
  //       setTimeout(() => {
  //         printWindow.print()
  //         setTimeout(() => printWindow.close(), 1000)
  //       }, 500)
  //     }
  //   }
  // }

  // const handleDownloadBadge = () => {
  //   const attendee = eventDetails.data?.[0]
  //   if (!attendee?.badge) {
  //     showToast("No badge available", "error")
  //     return
  //   }
  //   console.log("Triggering badge download...")
  //   const htmlContent = attendee.badge

  //   const bgUrlMatch = htmlContent.match(/background:url\(['"]([^'"]+)['"]\)/)
  //   const bgUrl = bgUrlMatch ? bgUrlMatch[1] : ""

  //   const preloadImg = new Image()
  //   preloadImg.src = bgUrl

  //   preloadImg.onload = () => {
  //     console.log("Background image loaded")
  //     const printWindow = window.open("", "_blank", "width=800,height=600")
  //     if (printWindow) {
  //       printWindow.document.write(`
  //         <!DOCTYPE html>
  //         <html>
  //         <head>
  //           <title>Badge</title>
  //           <style>
  //             @media print {
  //               * {
  //                 -webkit-print-color-adjust: exact !important;
  //                 color-adjust: exact !important;
  //                 print-color-adjust: exact !important;
  //               }
  //               body {
  //                 margin: 0 !important;
  //                 padding: 0 !important;
  //                 -webkit-print-color-adjust: exact !important;
  //               }
  //               .badge {
  //                 background-image: url('${bgUrl}') !important;
  //                 background-size: cover !important;
  //                 background-position: center !important;
  //                 background-repeat: no-repeat !important;
  //                 -webkit-print-color-adjust: exact !important;
  //                 width: 384px !important;
  //                 height: 576px !important;
  //                 margin: 0 auto !important;
  //                 page-break-inside: avoid !important;
  //               }
  //               .text-field {
  //                 -webkit-print-color-adjust: exact !important;
  //                 color: inherit !important;
  //               }
  //               .qr {
  //                 -webkit-print-color-adjust: exact !important;
  //               }
  //             }
  //             body {
  //               font-family: Arial, sans-serif;
  //               margin: 0;
  //               padding: 20px;
  //               background: white;
  //             }
  //             .badge {
  //               position: relative;
  //               width: 384px;
  //               height: 576px;
  //               margin: 0 auto;
  //               border: 1px solid #ccc;
  //               border-radius: 8px;
  //               overflow: hidden;
  //             }
  //             .text-field {
  //               position: absolute;
  //               padding: 10px 14px;
  //               font-size: 16px;
  //               font-family: 'Arial', sans-serif;
  //               font-weight: 400;
  //               color: #333333;
  //               text-align: center;
  //               background: transparent;
  //               border: none;
  //               outline: none;
  //               pointer-events: none;
  //               white-space: nowrap;
  //               overflow: hidden;
  //               text-overflow: ellipsis;
  //               line-height: 1.2;
  //               width: 200px;
  //               height: 50px;
  //             }
  //           </style>
  //         </head>
  //         <body>
  //           ${htmlContent.replace(/<body>/, "").replace(/<\/body><\/html>/, "</body></html>")}
  //           <script>
  //             window.onload = function() {
  //               setTimeout(function() {
  //                 window.print();
  //                 setTimeout(function() {
  //                   window.close();
  //                 }, 1000);
  //               }, 500);
  //             };
  //           </script>
  //         </body>
  //         </html>
  //       `)
  //       printWindow.document.close()
  //     }
  //   }

  //   preloadImg.onerror = () => {
  //     console.error("Failed to load background image")
  //     const printWindow = window.open("", "_blank", "width=800,height=600")
  //     if (printWindow) {
  //       printWindow.document.write(htmlContent)
  //       printWindow.document.close()
  //       setTimeout(() => {
  //         printWindow.print()
  //         setTimeout(() => printWindow.close(), 1000)
  //       }, 500)
  //     }
  //   }
  // }
    const handleDownloadCertificate = () => {
      const attendeeData = eventDetails.data?.[0];
      if (!attendeeData?.certificate) {
        showToast("No certificate available", "error");
        return;
      }
  const attendeeId =attendeeData.id
      const eventId =attendeeData.event_id
  DownloadCertificate(attendeeId, eventId)
      .then((res) => {
        console.log(res)
  
        window.open(`${localserver}/downloadCertificate/${eventId}/${attendeeId}`, '_blank')
      })
      .catch((err) => {
        showToast("Failed to download badge", "error");
        console.error(err)
      })
      }
  const handleDownloadBadge = () => {
    const attendeeData = eventDetails.data?.[0];
      console.log(attendeeData,"attendeeData")
      if (!attendeeData?.badge) {
        showToast("No badge available", "error");
        return;
      }
      const attendeeId =attendeeData.id
      const eventId =attendeeData.event_id
  DownloadBadge(attendeeId, eventId)
      .then((res) => {
        console.log(res)
  
        window.open(`${localserver}/downloadBadgePDF/${eventId}/${attendeeId}`, '_blank')
      })
      .catch((err) => {
        showToast("Failed to download badge", "error");
        console.error(err)
      })
    }

  useEffect(() => {
    if (triggerDownload && invoiceRef.current && !isCertificateDownload && !isBadgeDownload) {
      invoiceRef.current.handleDownloadPDF()
      setTriggerDownload(false)
    }
  }, [triggerDownload, isCertificateDownload, isBadgeDownload])

  const parseFormData = (formData) => {
    try {
      const parsed = JSON.parse(formData || "[]")
      return parsed[0]?.custom_fields || []
    } catch (error) {
      console.error("Error parsing form_data:", error)
      return []
    }
  }

  const parseTicketData = (ticketDataStr) => {
    try {
      return JSON.parse(ticketDataStr || "{}")
    } catch (error) {
      console.error("Error parsing ticket_data:", error)
      return {}
    }
  }

  const attendee = eventDetails.data?.[0] || {}
  const formFields = parseFormData(attendee.form_data)
  const firstName =
    formFields.find((f) => f.name === "first_name" || f.label.toLowerCase().includes("first"))?.value ||
    attendee.first_name ||
    "N/A"
  const lastName =
    formFields.find((f) => f.name === "last_name" || f.label.toLowerCase().includes("last"))?.value ||
    attendee.last_name ||
    ""
  const attendeeEmail =
    formFields.find((f) => f.name === "email_address" || f.label.toLowerCase().includes("email"))?.value ||
    attendee.email ||
    "N/A"
  const ticketDataParsed = parseTicketData(attendee.ticket_data)
  const ticket = eventDetails.tickets?.[0] || {}
  const payments = eventDetails.payments || []

  const ticketPrice = Number.parseFloat(payments[0]?.total_ticket_amount || 0)
  const taxAmount = Number.parseFloat(payments[0]?.total_tax_amount || 0)
  const addonsAmount = Number.parseFloat(payments[0]?.total_addons_amount || 0)
  const couponAmount = Number.parseFloat(payments[0]?.coupon_applied_amount || 0)
  const subtotal = ticketPrice + addonsAmount
  const discountedSubtotal = subtotal - couponAmount
  const totalAmount = Number.parseFloat(payments[0]?.total_amount || 0)
  const dueAmount = totalAmount - (Number.parseFloat(payments[0]?.payment_received || 0) || 0)
  const couponPercentage = payments[0]?.coupon_applied_percentage || "0"

  const formatDate = (dateString) => {
    if (!dateString) return "N/A"
    return moment(dateString).format("DD MMM YYYY, hh:mm A")
  }

  const event = eventDetails.event || {}
  const eventName = event.event_name || "N/A"
  const eventDate = event.event_date || event.start_date || null
  const location = event.venue_name || event.venue || "N/A"

  return (
    <div>
    <Header /> 
    <div style={{ minHeight: "100vh", backgroundColor: "#f5f7fa", padding: "20px" }}>
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        {/* Header Section */}
        <div style={{ marginBottom: "30px" }}>
          <button
            onClick={() => history.goBack()}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 16px",
              backgroundColor: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              color: "#333",
            }}
          >
            <ArrowLeftIcon />
            Back
          </button>
        </div>

        {/* Main Grid Layout */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))", gap: "20px" }}>
          {/* Attendee Details Card */}
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <FaUserCircle style={{ fontSize: "24px", color: "#1e40af" }} />
              <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#1f2937" }}>Attendee Details</h2>
            </div>

            <div style={{ backgroundColor: "#f8fafc", padding: "20px", borderRadius: "10px", marginBottom: "20px" }}>
              <div
                style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      backgroundColor: "#3b82f6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: "20px",
                      fontWeight: "600",
                    }}
                  >
                    {firstName.charAt(0)}
                  </div>
                  <div>
                    <div style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>
                      {firstName} {lastName}
                    </div>
                    <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                      ID: {attendee.reg_code || "N/A"}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "6px 12px",
                    backgroundColor: "#dcfce7",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#16a34a",
                  }}
                >
                  <FaCheckCircle />
                  Confirmed
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                    First Name
                  </div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "500" }}>{firstName}</div>
                </div>
                <div>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                    Last Name
                  </div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "500" }}>{lastName}</div>
                </div>
              </div>

              <div style={{ marginTop: "16px" }}>
                <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                  Email Address
                </div>
                <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "500", wordBreak: "break-all" }}>
                  {attendeeEmail}
                </div>
              </div>
            </div>

            {/* Additional Attendee Information */}
            <div style={{ display: "grid", gap: "12px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px",
                  backgroundColor: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <FaIdCard style={{ fontSize: "18px", color: "#6b7280" }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "2px" }}>Registration ID</div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                    {attendee.reg_code || "N/A"}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px",
                  backgroundColor: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <FaCalendar style={{ fontSize: "18px", color: "#6b7280" }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "2px" }}>Registration Date</div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                    {attendee.reg_date ? moment(attendee.reg_date).format("DD MMM YYYY, hh:mm A") : "N/A"}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px",
                  backgroundColor: "#f8fafc",
                  borderRadius: "8px",
                }}
              >
                <FaTicketAlt style={{ fontSize: "18px", color: "#6b7280" }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "2px" }}>Ticket Type</div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                    {ticketDataParsed.title || ticket.ticket_name || "N/A"}
                  </div>
                </div>
              </div>
            </div>

            {/* Custom Form Fields */}
            {formFields.length > 0 && (
              <div style={{ marginTop: "20px", paddingTop: "20px", borderTop: "1px solid #e5e7eb" }}>
                <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937", marginBottom: "12px" }}>
                  Additional Information
                </div>
                <div style={{ display: "grid", gap: "12px" }}>
                  {formFields.map((field, index) => (
                    <div key={index} style={{ padding: "12px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
                      <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px" }}>{field.label}</div>
                      <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "500" }}>
                        {field.value || "N/A"}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Order Summary Card */}
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <FaReceipt style={{ fontSize: "24px", color: "#1e40af" }} />
              <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#1f2937" }}>Order Summary</h2>
            </div>

            {/* Ticket Details */}
            <div style={{ marginBottom: "20px" }}>
              <div style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "start",
                    marginBottom: "12px",
                  }}
                >
                  <div>
                    <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>
                      {ticketDataParsed.title || ticket.ticket_name || "N/A"}
                    </div>
                    <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                      {ticketDataParsed.description || ticket.description || ""}
                    </div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937" }}>
                      INR {ticketPrice.toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Pricing Breakdown */}
            <div style={{ marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "12px 0",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <div style={{ fontSize: "14px", color: "#6b7280" }}>Subtotal</div>
                <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>INR {subtotal.toFixed(2)}</div>
              </div>

              {addonsAmount > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px 0",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  <div style={{ fontSize: "14px", color: "#6b7280" }}>Add-ons</div>
                  <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>
                    INR {addonsAmount.toFixed(2)}
                  </div>
                </div>
              )}

              {couponAmount > 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "12px 0",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  <div style={{ fontSize: "14px", color: "#10b981" }}>
                    Discount {couponPercentage ? `(${couponPercentage}%)` : ""}
                  </div>
                  <div style={{ fontSize: "14px", fontWeight: "600", color: "#10b981" }}>
                    - INR {couponAmount.toFixed(2)}
                  </div>
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "12px 0",
                  borderBottom: "1px solid #e5e7eb",
                }}
              >
                <div style={{ fontSize: "14px", color: "#6b7280" }}>GST</div>
                <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937" }}>INR {taxAmount.toFixed(2)}</div>
              </div>
            </div>

            {/* Total Amount */}
            <div
              style={{
                padding: "16px",
                backgroundColor: "#1e40af",
                borderRadius: "10px",
                marginBottom: "24px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#fff" }}>Total</div>
                <div style={{ fontSize: "24px", fontWeight: "700", color: "#fff" }}>INR {totalAmount.toFixed(2)}</div>
              </div>
            </div>

            {/* Download Buttons */}
            <div style={{ display: "grid", gap: "12px" }}>
              <button
                onClick={handleDownloadInvoice}
                style={{
                  width: "100%",
                  padding: "14px",
                  backgroundColor: "#1e40af",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <FaDownload />
                Download Invoice
              </button>

              <button
                onClick={handleDownloadCertificate}
                style={{
                  width: "100%",
                  padding: "14px",
                  backgroundColor: "#10b981",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <FaDownload />
                Download Certificate
              </button>

              <button
                onClick={handleDownloadBadge}
                style={{
                  width: "100%",
                  padding: "14px",
                  backgroundColor: "#f59e0b",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <FaDownload />
                Download Badge
              </button>
            </div>
          </div>

          {/* Your Ticket Card */}
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <FaTicketAlt style={{ fontSize: "24px", color: "#1e40af" }} />
              <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#1f2937" }}>Your Ticket</h2>
            </div>

            <div style={{ padding: "20px", backgroundColor: "#f8fafc", borderRadius: "10px", marginBottom: "20px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                <div>
                  <div style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937", marginBottom: "8px" }}>
                    {ticketDataParsed.title || ticket.ticket_name || "N/A"}
                  </div>
                  <div style={{ fontSize: "14px", color: "#6b7280", marginBottom: "4px" }}>
                    {firstName} {lastName}
                  </div>
                </div>
                {attendee.qr && (
                  <div
                    style={{
                      width: "100px",
                      height: "100px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={attendee.qr}
                      alt="QR Code"
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Ticket Information Grid */}
            <div style={{ display: "grid", gap: "16px" }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
                <div style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>
                    Registration ID
                  </div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                    {attendee.reg_code || "N/A"}
                  </div>
                </div>

                <div style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>
                    Order ID
                  </div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                    {attendee.attendees_payments_id || "N/A"}
                  </div>
                </div>
              </div>

              <div style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>Email</div>
                <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600", wordBreak: "break-all" }}>
                  {attendeeEmail}
                </div>
              </div>

              <div style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>Ticket Type</div>
                <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                  {ticketDataParsed.title || ticket.ticket_name || "N/A"}
                </div>
              </div>

              <div style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
                <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>Event</div>
                <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                  {eventName}
                </div>
              </div>

              {eventDate && (
                <div style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>
                    Event Date
                  </div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                    {moment(eventDate).format("DD MMM YYYY, hh:mm A")}
                  </div>
                </div>
              )}

              {location !== "N/A" && (
                <div style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "8px" }}>
                  <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>
                    <FaMapMarkerAlt style={{ marginRight: "6px", verticalAlign: "middle" }} />
                    Location
                  </div>
                  <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>{location}</div>
                </div>
              )}
            </div>
          </div>

          {/* Payment Info Card */}
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <FaCreditCard style={{ fontSize: "24px", color: "#1e40af" }} />
              <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "600", color: "#1f2937" }}>Payment History</h2>
            </div>

            {/* Overall Payment Status */}
            <div
              style={{
                padding: "16px",
                backgroundColor: "#dcfce7",
                borderRadius: "10px",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <FaCheckCircle style={{ fontSize: "24px", color: "#16a34a" }} />
              <div>
                <div style={{ fontSize: "16px", fontWeight: "600", color: "#16a34a" }}>
                  {payments.length} Payment{payments.length > 1 ? 's' : ''} Processed Successfully
                </div>
                <div style={{ fontSize: "12px", color: "#15803d", marginTop: "2px" }}>
                  Total Paid: INR {payments.reduce((sum, pay) => sum + Number.parseFloat(pay.payment_received || 0), 0).toFixed(2)}
                </div>
              </div>
            </div>

            {/* Payment Records List */}
            <div style={{ display: "grid", gap: "16px" }}>
              {payments.map((pay, index) => (
                <div
                  key={pay.id || index}
                  style={{
                    padding: "20px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "10px",
                    border: `1px solid ${pay.payment_status === 'Success' ? '#dcfce7' : '#fef2f2'}`,
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                    <div style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937" }}>
                      Payment #{pay.id}
                    </div>
                    <div
                      style={{
                        padding: "6px 12px",
                        backgroundColor: pay.payment_status === 'Success' ? "#dcfce7" : "#fef2f2",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                        color: pay.payment_status === 'Success' ? "#16a34a" : "#dc2626",
                      }}
                    >
                      {pay.payment_status || "Pending"}
                    </div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "12px" }}>
                    <div style={{ padding: "12px", backgroundColor: "#fff", borderRadius: "6px" }}>
                      <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                        Amount Paid
                      </div>
                      <div style={{ fontSize: "16px", color: "#16a34a", fontWeight: "700" }}>
                        INR {Number.parseFloat(pay.payment_received || 0).toFixed(2)}
                      </div>
                    </div>

                    <div style={{ padding: "12px", backgroundColor: "#fff", borderRadius: "6px" }}>
                      <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                        Payment Date
                      </div>
                      <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                        {formatDate(pay.payment_date || pay.created_at)}
                      </div>
                    </div>

                    <div style={{ padding: "12px", backgroundColor: "#fff", borderRadius: "6px" }}>
                      <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                        Method
                      </div>
                      <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                        {pay.payment_method === "Razorpay" ? "Online" : pay.payment_method || "N/A"}
                      </div>
                    </div>

                    <div style={{ padding: "12px", backgroundColor: "#fff", borderRadius: "6px" }}>
                      <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                        Gateway
                      </div>
                      <div style={{ fontSize: "14px", color: "#1f2937", fontWeight: "600" }}>
                        {pay.payment_id ? "Razorpay" : "Offline"}
                      </div>
                    </div>

                    {pay.payment_id && (
                      <div style={{ padding: "12px", backgroundColor: "#fff", borderRadius: "6px", gridColumn: "1 / -1" }}>
                        <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                          Reference ID
                        </div>
                        <div style={{ fontSize: "12px", color: "#1f2937", fontWeight: "600", wordBreak: "break-all" }}>
                          {pay.payment_id}
                        </div>
                      </div>
                    )}

                    {pay.purchase_id && (
                      <div style={{ padding: "12px", backgroundColor: "#fff", borderRadius: "6px" }}>
                        <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "4px", fontWeight: "500" }}>
                          Purchase ID
                        </div>
                        <div style={{ fontSize: "12px", color: "#1f2937", fontWeight: "600", wordBreak: "break-all" }}>
                          {pay.purchase_id}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {payments.length === 0 && (
              <div style={{ textAlign: "center", padding: "40px", color: "#6b7280" }}>
                No payment records found.
              </div>
            )}
          </div>
        </div>
          {triggerDownload && (
            <div style={{ position: "absolute", left: "-9999px" }}>
              <EventInvoice
                ref={invoiceRef}
                invoiceData={eventDetails}
                autoDownload={true}
              />
            </div>
          )}
        <ToastMessage />
      </div>
    </div>
    <Footer/>
    </div> 
  )
}

export default UserEventPreviewPage